/**
 * Merges multiple refs into one. Works with either callback or object refs.
 */
export function mergeRefs(...refs) {
  if (refs.length === 1 && refs[0]) {
    return refs[0];
  }
  return value => {
    let hasCleanup = false;
    const cleanups = refs.map(ref => {
      const cleanup = setRef(ref, value);
      if (typeof cleanup === 'function') {
        hasCleanup = true;
      }
      return cleanup;
    });
    if (hasCleanup) {
      return () => {
        cleanups.forEach((cleanup, i) => {
          if (typeof cleanup === 'function') {
            cleanup();
          } else {
            setRef(refs[i], null);
          }
        });
      };
    }
  };
}
function setRef(ref, value) {
  if (typeof ref === 'function') {
    return ref(value);
  } else if (ref != null) {
    ref.current = value;
  }
}